import React from 'react';
import type { IconProps } from '../types';

export const PinFill = (props: IconProps) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>icon-pin-fill</title>
    <g
      id="icon-pin-fill"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="24"
        height="24"
        rx="4"
      ></rect>
      <path
        d="M6.60822653,11.9185094 L12.4722476,17.7825305 C13.3039432,16.88156 13.5654769,15.59278 13.1507792,14.4388774 L17.647936,9.94247454 L17.7813806,10.0751652 C18.1510591,10.4324165 18.7388453,10.4274758 19.1024662,10.0640606 C19.4660871,9.70064533 19.4713604,9.11286206 19.1143182,8.74298142 L15.6462677,5.27493091 C15.2775626,4.90747491 14.6807861,4.90848754 14.3133301,5.27719268 C13.9458741,5.64589783 13.9468867,6.24267435 14.3155918,6.61013036 L14.4490364,6.74357491 L9.95187958,11.2407317 C8.7980766,10.8263652 7.50959437,11.087548 6.60822653,11.9185094 Z"
        id="Path"
        stroke="currentColor"
        fill="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <line
        x1="9.54023706"
        y1="14.8505199"
        x2="4.5"
        y2="19.890757"
        id="Path"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></line>
    </g>
  </svg>
);

export default PinFill;
